import type {Conversation} from "@khan/guide-types";

export function downloadConversation(
    threadId: string | null | undefined,
    conversation: Conversation,
) {
    const conversationString = conversation
        .map((message) => {
            // The backend uses the internal names "Teacher" and "Student"
            // for the assistant and user, respectively, regardless of
            // the user's role on KA (i.e. the backend uses "Student" for
            // the user even if they're a teacher). We plan to move away
            // from this terminology in the near future, but for now we
            // translate the names for display.
            let displayUser: string = message.user as any;

            // sync-start:ai-guide-teacher-student 134592341 https://github.com/Khan/webapp/blob/master/services/ai-guide/models/client_conversation_entry.go
            if (displayUser === "Teacher") {
                displayUser = "Assistant";
            }

            if (displayUser === "Student") {
                displayUser = "User";
            }
            // sync-end:ai-guide-teacher-student

            return `${displayUser}:\n${message.text}`;
        })
        .join("\n\n\n");

    const blob = new Blob([conversationString], {type: "text/plain"});
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = `${threadId ?? "khanmigo-conversation"}.txt`;
    link.href = url;

    link.click();
}
